export enum Ga4EventType {
  avg_FPS = 'avg_FPS',
  godzi_loading = 'godzi_loading',
  godzi_loading_time = 'godzi_loading_time',
  tutorial_loading_time = 'tutorial_loading_time',
  enter_main_game = 'enter_main_game',
  close_promotion_panel = 'close_promotion_panel',
  spin_with_auto = 'spin_with_auto',
  spin_with_speed = 'spin_with_speed',
  spin_with_immediate = 'spin_with_immediate',
  main_bet = 'main_bet',
  main_bet_bonus = 'main_bet_bonus',
  main_bet_extra = 'main_bet_extra',
  autoplay_25 = 'autoplay_25',
  autoplay_50 = 'autoplay_50',
  autoplay_100 = 'autoplay_100',
  autoplay_250 = 'autoplay_250',
  autoplay_500 = 'autoplay_500',
  autoplay_1000 = 'autoplay_1000',
  autoplay_infinity = 'autoplay_infinity',
  menu_close_music = 'menu_close_music',
  menu_betting_rules = 'menu_betting_rules',
  menu_history = 'menu_history',
  menu_lobby = 'menu_lobby',
  stay_time_10 = 'stay_time_10',
  stay_time_20 = 'stay_time_20',
  stay_time_30 = 'stay_time_30',
  stay_time_60 = 'stay_time_60',
  stay_time_120 = 'stay_time_120',
  stay_time_180 = 'stay_time_180',
  table_limit_loading_time = 'table_limit_loading_time',
  back_to_table_limit = 'back_to_table_limit',
  record_video = 'record_video',
  record_video_share = 'record_video_share',
  record_video_download = 'record_video_download',
  record_video_error = 'record_video_error',
  record_video_abort = 'record_video_abort',
  record_video_over_time = 'record_video_over_time',
  // old ga
  main_bet_auto = 'main_bet_auto',
  main_bet_manual = 'main_bet_manual',
  main_bet_with_extra = 'main_bet_with_extra',
  main_bet_autoplay = 'main_bet_autoplay',
  menu_history_detail_game = 'menu_history_detail_game',
  menu_history_detail_godzi = 'menu_history_detail_godzi',
  menu_history_detail_mg = 'menu_history_detail_mg',
  menu_history_detail_fg = 'menu_history_detail_fg',
  start_with_portrait = 'start_with_portrait',
  start_with_landscape = 'start_with_landscape',
  manul_change_orientation = 'manul_change_orientation',
}
